import React, { useEffect, useState } from "react";
import { ArrowRight, Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT, SOCIAL } from "../data/site";
import FlowerDivider from "../components/FlowerDivider";

export default function Kontakt() {
  const { t } = useLang();
  const [sent, setSent] = useState(false);
  useEffect(() => window.scrollTo({ top: 0 }), []);

  return (
    <main className="pt-28 md:pt-32" data-testid="kontakt-page">
      <section className="py-14 md:py-20">
        <div className="container-x text-center">
          <h1 className="display text-4xl sm:text-5xl md:text-7xl">{t.contact.label}</h1>
          <FlowerDivider />
          <p className="text-[var(--ink-soft)]">{t.contact.sub}</p>
        </div>

        <div className="container-x grid md:grid-cols-12 gap-8 md:gap-10 mt-10 md:mt-14">
          <ul className="md:col-span-5 space-y-5 text-[15px]">
            <li className="flex items-start gap-4">
              <span className="w-10 h-10 rounded-full bg-[var(--gold)]/15 flex items-center justify-center text-[var(--gold-dark)] shrink-0"><Phone size={16} /></span>
              <div>
                <div className="text-xs tracking-[0.25em] uppercase text-[var(--ink-soft)]">{t.contact.phone}</div>
                <a href={`tel:${CONTACT.phoneLink}`} className="text-base md:text-lg">{CONTACT.phone}</a>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="w-10 h-10 rounded-full bg-[var(--gold)]/15 flex items-center justify-center text-[var(--gold-dark)] shrink-0"><Mail size={16} /></span>
              <div>
                <div className="text-xs tracking-[0.25em] uppercase text-[var(--ink-soft)]">{t.contact.email}</div>
                <a href={`mailto:${CONTACT.email}`} className="text-base md:text-lg break-all">{CONTACT.email}</a>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="w-10 h-10 rounded-full bg-[var(--gold)]/15 flex items-center justify-center text-[var(--gold-dark)] shrink-0"><MapPin size={16} /></span>
              <div>
                <div className="text-xs tracking-[0.25em] uppercase text-[var(--ink-soft)]">{t.contact.address}</div>
                <div className="text-base md:text-lg">{CONTACT.street}, {CONTACT.zip} {CONTACT.city}</div>
                <div className="text-sm text-[var(--ink-soft)]">{CONTACT.country}</div>
              </div>
            </li>
            <li className="pt-3">
              <div className="text-xs tracking-[0.25em] uppercase text-[var(--ink-soft)] mb-3">{t.contact.social}</div>
              <div className="flex items-center gap-3 flex-wrap">
                <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className="btn btn-ghost"><Instagram size={16} /> Instagram</a>
                <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-ghost"><Facebook size={16} /> Facebook</a>
              </div>
            </li>
          </ul>

          <form
            action={`https://formsubmit.co/${CONTACT.email}`}
            method="POST"
            onSubmit={() => setSent(true)}
            className="md:col-span-7 bg-[var(--cream-soft)] p-6 md:p-10 rounded-3xl border border-[var(--line)]"
            data-testid="sub-contact-form"
          >
            <div className="font-serif text-2xl md:text-3xl mb-4 md:mb-5">{t.contact.send}</div>
            <input type="hidden" name="_subject" value="Lotus Sutra – Neue Anfrage" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_next" value="https://lotussutra.at/kontakt" />
            <input type="text" name="_honey" style={{ display: "none" }} tabIndex={-1} autoComplete="off" />

            <input required name="name" className="field" placeholder={t.contact.namePh} />
            <input required type="email" name="email" className="field" placeholder={t.contact.emailPh} />
            <textarea required name="message" className="field" placeholder={t.contact.msgPh} rows={5} />
            <div className="flex items-center justify-between mt-5 md:mt-6 flex-wrap gap-3">
              <button className="btn btn-primary" type="submit">{t.contact.send} <ArrowRight size={14} /></button>
              {sent && <span className="text-sm text-[var(--gold-dark)]">✓ {t.contact.sent}</span>}
            </div>
            <p className="mt-3 md:mt-4 text-xs text-[var(--ink-soft)]">
              Nachrichten werden direkt an <a href={`mailto:${CONTACT.email}`} className="underline">{CONTACT.email}</a> zugestellt.
            </p>
          </form>
        </div>
      </section>
    </main>
  );
}
